import React, { useEffect, useState } from 'react';
import { withRouter } from "../hooks/withRouter";
import { getImpuestosDetalle } from '../api/consulaImpuestosApi';
// Importar el componente FontAwesomeIcon de la biblioteca '@fortawesome/react-fontawesome'
import { Link } from "react-router-dom";
// Importar el ícono faSignOutAlt de la biblioteca '@fortawesome/free-solid-svg-icons'
import { UseAuth } from "../hooks/useAuth";

function BusquedaImpuestosDetalle(props) {
    const { location } = props.router;
    const { accessToken } = UseAuth();

    const [result, setResult] = useState([]);
    const url = location.pathname.split("/");
    const NO_PERSONA = url[2];


    useEffect(() => {
        getImpuestosDetalle(accessToken, NO_PERSONA).then((response) => {
            if (response?.code !== 200) {
                setResult(response);
            } else {
            }
        }).catch(() => {
        });
    }, [accessToken, NO_PERSONA]);
    const formatDate = (date) => {
        if (!date) return ""; // Manejar fechas nulas o indefinidas

        // Convertir la fecha a un objeto Date
        const formattedDate = new Date(date);

        // Obtener el día, mes y año
        const day = formattedDate.getDate();
        const month = formattedDate.getMonth() + 1; // Los meses en JavaScript son indexados desde 0
        const year = formattedDate.getFullYear();

        // Formatear la fecha en el formato "DD/MM/AAAA"
        return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
    };


    if (result.length < 1) {
        return "loading";
    }

    return (

<div>
        <div className='top-bar2'>
            <div className="top-bar">

                <div className="logo">
                    {/* Botón con apariencia de logo que lleva a la página principal */}
                    <Link to="/">
                        <button className="logo-button">
                            <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                        </button>
                    </Link>
                </div>
            </div>
            </div>
            <>
            <div class="acta-container">
                            <h1>Padron Impuestos</h1>
                {result.map((res, index) => (
                    <div key={index}>
                        <h1>{res.CONTRIBUYENTE}</h1>
                        <div className="acta" >
                            <div className='column'>
                                <h1>RFC</h1>
                                <p className="letra">{res.rfc}</p>
                                <h1>Curp</h1>
                                <p className="letra">{res.curp}</p>
                                <h1>Contribuyente</h1>
                                <p className="letra">{res.contribuyente}</p>
                                <h1>Nombre Comercial</h1>
                                <p className="letra">{res.nombre_comercial}</p>
                                <h1>Razon Social</h1>
                                <p className="letra">{res.razon_social}</p>
                                <h1>Domicilio</h1>
                                <p className="letra">{res.domicilio}</p>
                                <h1>Telefono</h1>
                                <p className="letra">{res.telefono}</p>
                                <h1>Email</h1>
                                <p className="letra">{res.email}</p>
                            </div>

                            <div className='column'>
                                <h1>Fecha de Alta</h1>
                                <p className="letra">{res.fecha_de_alta}</p>

                                <h1>Tipo de Persona</h1>
                                <p className="letra">{res.tipo_de_persona}</p>
                                <h1>Actividad Economica</h1>
                                <p className="letra">{res.actividad_economica}</p>
                                <h1>Situacion</h1>
                                <p className="letra">{res.situacion}</p>
                                <h1>No Empleados</h1>
                                <p className="letra">{res.no_empleados}</p>
                                <h1>Impuesto</h1>
                                <p className="letra">{res.impuesto}</p>
                                <h1>Actividad</h1>
                                <p className="letra">{res.actividad}</p>
                                <h1>Estatus</h1>
                                <p className="letra">{res.estatus}</p>
                                <h1>Inicio de Obligaciones</h1>
                                <p className="letra">{res.inicio_de_obligaciones}</p>


                            </div>
                        </div>
                    </div>
                ))}
                </div>
            </>
        </div>


    );
}


export default withRouter(BusquedaImpuestosDetalle);



